// AYA PRO — Shell commun : header sticky (logo or, chip profil, bascule AYA normal).
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getProProfile, setProProfile, setSpace, PROFILE_META } from "@/pro/proSpace";
import "@/pro/proTheme.css";

export default function ProShell({ children, onProfileChange }) {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(getProProfile());
  const [menuOpen, setMenuOpen] = useState(false);
  const meta = PROFILE_META[profile] || PROFILE_META.commercant;

  const switchProfile = (id) => {
    setProProfile(id);
    setProfile(id);
    setMenuOpen(false);
    if (onProfileChange) onProfileChange(id);
  };
  const goNormal = () => {
    setSpace("normal");
    navigate("/");
  };

  return (
    <div className="pro-root" data-testid="pro-shell">
      <header className="pro-header">
        <Link to="/pro" className="pro-logo" data-testid="pro-logo-link">
          <img src="/aya/splash.png" alt="" className="pro-logo-mask" />
          <span className="pro-logo-text">AYA <b>PRO</b></span>
        </Link>
        <div className="pro-header-right">
          <button
            className="pro-chip"
            data-testid="pro-profile-chip"
            onClick={() => setMenuOpen((o) => !o)}
          >
            {meta.icon} {meta.label} ▾
          </button>
          <button className="pro-chip pro-chip-ghost" data-testid="pro-switch-normal-btn" onClick={goNormal}>
            🌿 AYA
          </button>
          {menuOpen && (
            <div className="pro-profile-menu" data-testid="pro-profile-menu">
              {Object.entries(PROFILE_META).map(([id, m]) => (
                <button
                  key={id}
                  className={id === profile ? "active" : ""}
                  data-testid={`pro-profile-option-${id}`}
                  onClick={() => switchProfile(id)}
                >
                  {m.icon} {m.label}
                </button>
              ))}
            </div>
          )}
        </div>
      </header>
      <div className="pro-container">{children}</div>
    </div>
  );
}
